import { makeAutoObservable } from 'mobx';
import { IChangeable } from '../../../stores/types';
import { ITemplate } from '../emailContentTypes';

interface ITemplateChanges extends Partial<ITemplate> {}

class TemplateStore implements IChangeable<ITemplate> {
	private _changes: ITemplateChanges = {};
	private _model?: ITemplate | null;

	constructor(model?: ITemplate) {
		this._setModel(model);
		makeAutoObservable(this);
	}

	getUpdatedModel(): ITemplate {
		return { ...this._model, ...this._changes, _has_changes: this.hasChanges() };
	}

	public get deleted() {
		return this._changes._deleted ?? false;
	}
	public get locale() {
		return this._changes.locale ?? this._model?.locale;
	}
	public get content() {
		return this._changes.content ?? this._model?.content;
	}

	public setContent(value: string | null) {
		if (this._changes.content === value) {
			return;
		}
		this._changes.content = value;
	}

	setChanges(template: ITemplateChanges) {
		this._changes = template;
	}

	hasChanges(): boolean {
		return !!Object.keys(this._changes).length;
	}

	discardChanges(): void {
		this._changes = {} as ITemplateChanges;
	}

	private _setModel(model?: ITemplate | null): void {
		this._model = model;
		this._changes = {} as ITemplateChanges;
	}
}

export default TemplateStore;
